import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';

import { MinimalUser } from 'api';

interface PropTypes<T extends MinimalUser = MinimalUser> {
  prefix: string;
  date?: string | null;
  user?: T | null;
}

dayjs.extend(calendar);

export default function DateModified({ prefix, date, user }: PropTypes) {
  const getUserName = (user?: MinimalUser | null) => {
    if (!user) {
      return '';
    }

    return ` by ${user.nickname ?? user.first_name ?? ''} ${user.last_name ?? ''}`;
  };

  if (!date) {
    return null;
  }

  return (
    <Typography variant="subtitle2">
      <strong>{prefix}</strong>
      {`${dayjs(date).calendar(null, {
        sameElse: 'MMM D, YYYY [at] h:mm a',
      })} ${getUserName(user)}`}
    </Typography>
  );
}
